module.exports = __webpack_public_path__ + "img/sv17.55da47fc.svg";